// Seleccionamos los elementos que tienen el atributo 'data-bs-toggle' con valor 'tooltip'
document.addEventListener('DOMContentLoaded', function () {
    initializeTooltips();
});

window.initializeTooltips = function () {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    // Para cada uno de estos elementos, se crea un nuevo tooltip de Bootstrap con activación manual y contenido HTML
    tooltipTriggerList.forEach(function (tooltipTriggerEl) {
        // Verificar si el elemento tooltip está ya inicializado
        if (!bootstrap.Tooltip.getInstance(tooltipTriggerEl)) {
            const tooltip = new bootstrap.Tooltip(tooltipTriggerEl, {
                trigger: 'manual',
                html:    true
            });
            tooltipTriggerEl.addEventListener('mouseenter', function () {

                // Mostrar tooltip al pasar el cursor sobre el elemento
                tooltip.show();

                const tooltipElement = document.querySelector('.tooltip');

                // Añadir clases específicas de estilos a los tooltips
                const textAlignmentClasses = [
                    'text-end-tooltip',
                    'text-start-tooltip'
                ];
                textAlignmentClasses.forEach(function (alignmentClass) {
                    if (tooltipTriggerEl.classList.contains(alignmentClass)) {
                        tooltipElement.classList.add(alignmentClass);
                    }
                });

                const tooltipInner = document.querySelector('.tooltip-inner');

                // Esconder el tooltip cuando el cursor sale del elemento
                tooltipTriggerEl.addEventListener('mouseleave', function (event) {
                    if ((!tooltipElement.contains(event.relatedTarget) && !tooltipTriggerEl.contains(event.relatedTarget))) {
                        tooltip.hide();
                    }
                });

                // Esconder el tooltip cuando el cursor sale de él
                if ((!tooltipElement.contains(event.relatedTarget) && !tooltipTriggerEl.contains(event.relatedTarget))) {
                    tooltipInner.addEventListener('mouseleave', function () {
                        tooltip.hide();
                    });
                }

                // Esconder el tooltip cuando el menu de usuario se muestra
                $('#menuTopDropdownUsuario').on('click', function () {
                    tooltip.hide();
                });
                if ($('[aria-labelledby="menuTopDropdownUsuario"]').is(':visible')) {
                    tooltip.hide();
                }
            });
        }
    });
}
